/* global Sentry */
/* eslint-disable no-confusing-arrow */
import '@/styles/global.scss';
import { createHead, VueHeadMixin } from '@unhead/vue/client';
import { createApp } from 'vue';
import { createGtm } from 'vue-gtm';
import appComponent from '@/components/app/app.vue';
import env from '@/env';
import registerGlobals from '@/plugins/register-globals';
import router from '@/router';
import { startTheme } from '@/services/theme';
import store from '@/store';
import getIndex2RedirectUrl from '@/utils/redirect';

const app = createApp(appComponent);

app.use(store);
app.use(router);

app.use(createHead());
app.mixin(VueHeadMixin);
registerGlobals(app);

// GTM script itself is already injected via the manual snippet in index.html;
// this plugin is only used for the $gtm.trackEvent()/trackView() dataLayer helpers.
app.use(
  createGtm({
    id: env.GOOGLE_GTM,
    loadScript: false,
    debug: env.NODE_ENV === 'development',
  }),
);

if (typeof Sentry !== 'undefined' && env.NODE_ENV !== 'development' && env.SENTRY_DSN) {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: env.SENTRY_ENVIRONMENT || env.NODE_ENV,
  });
}

const index2RedirectUrl = getIndex2RedirectUrl();
if (index2RedirectUrl) {
  window.location.replace(index2RedirectUrl);
} else {
  const stopTheme = startTheme(store);
  app.onUnmount(stopTheme);
  if (import.meta.hot) import.meta.hot.dispose(stopTheme);
  app.mount('#app');
}
